import { INote, IByte, IImportants } from "../types/INote";

export type IData = INote | IImportants;

export const findNote = <T extends IData>(notes: T[], newNote: T) => {
  return notes.find((n: T) => n.id === newNote.id);
};

export const updateNotes = <T extends IData>(notes: T[], newNote: T): T[] => {
  return notes.map((n: T) => {
    if (n.id === newNote.id) {
      return newNote;
    } else {
      return n;
    }
  });
};

export const deleteNote = <T extends IData>(list: T[], id: string) => {
  return list.filter((e: T) => e.id !== id);
};

export const prepareData = (byte: IByte, data?: string) => {
  if (data?.trim()) {
    try {
      const parts: string[] = data.split("\n\n");
      const body: string = parts[1].replace(byte.NULL, "");

      if (body) {
        return JSON.parse(body);
      }
    } catch {}
  }
};

export const byte = {
  LF: "\x0A",
  NULL: "\x00",
};

export const WSFrame = (command: string, headers: { [key: string]: string }, byte: { LF: string; NULL: string }) => {
  return (
    command.toUpperCase() +
    byte.LF +
    Object.keys(headers)
      .map((e) => e + ":" + headers[e])
      .join(byte.LF) +
    byte.LF +
    byte.LF +
    byte.NULL
  );
};
